<div #menuTrigger class="language-select-menu-item mat-mdc-menu-item">
	<ogs-m3-icon icon="globe" />
	<span class="mat-body-medium">{{"Sprache" | translate : "label-language"}}</span>
	<span class="spacer"></span>
	<ogs-m3-icon icon="chevron-right" />
</div>

<!--REFACTOR: remove offset and refactor floating directive-->
<mat-list class="language-select__menu" appFloating alignment="start" [triggerRef]="menuTrigger"
	[offsetRef]="menuTrigger" position="left" [offsetX]="-5" triggerMode="hover">
	@for (locale of _languageSelectionService.locales; track $index) {
	<mat-list-item class="mat-mdc-list-item-interactive" (click)="onSelectionChange(locale)">
		<div class="language-select__language-item">
			{{locale.localizedName.defaultText | translate : locale.localizedName.token : locale.localizedName.scope}}
			@if (currentLocale() && _languageSelectionService.compareLocales(locale, currentLocale()!)) {
			<mat-pseudo-checkbox [appearance]="'minimal'" [state]="'checked'" />
			}
		</div>
	</mat-list-item>
	}
</mat-list>